import { Grid, Stack, Typography } from "@mui/material";
import { workOrderBusiness } from "api/bussiness/work-order/work-order-bussiness";
import { DepartmentProcess } from "commons/enum/deparment-process";
import { WorkOrdersPermission } from "commons/enum/permission";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { CustomerDealingAndActiveInfo } from "pages/common/customer-dealing-and-active-info";
import { ProductNameAndActiveInfo } from "pages/common/product-name-and-active-info";
import { useCallback, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { NumberText } from "share-components/atomics/number-text";
import { PropertyInfo } from "share-components/atomics/property-info";
import {
  EditButton,
  GoBackIconButton,
  RemoveButton,
} from "share-components/mui-wrap/button/action-button";
import { PageContentScrollableContainer } from "share-components/templates/page/page-content-container";
import { PageDetailContainer } from "share-components/templates/page/page-detail-container";
import { PageHeaderContainer } from "share-components/templates/page/page-header-container";
import { EditWorkOrder } from "../edit-work-order/edit-work-order";
import { DepartmentProcessItem } from "./department-process-item";
import { PackagePrintPreview } from "./package-print-preview/package-print-preview";
import { UpdateDepartmentProcess } from "./update-department-process/update-department-process";
export const WorkOrderDetail = observer(() => {
  const { workOrderId } = useParams();
  const {
    workOrderManagement: {
      getWorkOrderDetail,
      openEdit,
      openPackagePrint,
      updateDepartmentProcess: { open: openUpdateDepartmentProcess },
    },
  } = useStores();
  useEffect(() => {
    if (workOrderId) {
      getWorkOrderDetail(workOrderId);
    }
  }, [getWorkOrderDetail, workOrderId]);
  return (
    <PageDetailContainer>
      <PageHeaderContainer direction={"row"} justifyContent={"space-between"}>
        <Header></Header>
      </PageHeaderContainer>
      <PageContentScrollableContainer>
        <Content></Content>
      </PageContentScrollableContainer>

      <>
        {openPackagePrint && <PackagePrintPreview></PackagePrintPreview>}
        {openEdit && <EditWorkOrder></EditWorkOrder>}
        {openUpdateDepartmentProcess && (
          <UpdateDepartmentProcess></UpdateDepartmentProcess>
        )}
      </>
    </PageDetailContainer>
  );
});
type HeaderProps = {};
const Header = observer((props: HeaderProps) => {
  const {
    workOrderManagement: {
      workOrderDetail,
      setProp: setWorkOrderManagementProp,
    },
    deleteConfirmationStore: { setProp, setDeletionCallback },
  } = useStores();
  const navigate = useNavigate();
  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);
  const onDelete = useCallback(
    async (id: string) => {
      if (id) {
        await workOrderBusiness.delete(id);
        goBack();
      }
    },
    [goBack]
  );
  const removeHandler = useCallback(() => {
    setProp("open", true);
    setDeletionCallback(() => {
      if (!workOrderDetail?.id) return;
      onDelete(workOrderDetail?.id);
    });
  }, [workOrderDetail, onDelete, setDeletionCallback, setProp]);

  const editHandler = useCallback(() => {
    setWorkOrderManagementProp("openEdit", true);
  }, [setWorkOrderManagementProp]);

  return (
    <>
      <Stack
        direction={"row"}
        justifyItems={"center"}
        spacing={1}
        alignItems={"center"}
      >
        <GoBackIconButton onClick={goBack}></GoBackIconButton>
        <Typography variant="subtitle2">{`Thông tin chi tiết `}</Typography>
      </Stack>
      <Stack direction={"row"} justifyItems={"center"} spacing={1}>
        <RemoveButton
          accessPermission={[WorkOrdersPermission.Delete]}
          onClick={removeHandler}
        ></RemoveButton>

        <EditButton
          accessPermission={[WorkOrdersPermission.Update]}
          onClick={editHandler}
        ></EditButton>
      </Stack>
    </>
  );
});

const Content = observer(() => {
  const {
    workOrderManagement: { workOrderDetail },
  } = useStores();

  const workOrderItem = useMemo(() => {
    return workOrderDetail?.items?.[0];
  }, [workOrderDetail?.items]);
  return (
    <Stack padding={1}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <PropertyInfo
            title="Ngày:"
            value={dateTimeDisplay(workOrderDetail?.date || "")}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Số:"
            value={workOrderDetail?.woNumber || ""}
          ></PropertyInfo>
        </Grid>
        <Grid item xs={6}>
          <PropertyInfo
            title="Tên giao dịch:"
            value={
              workOrderDetail?.customer ? (
                <CustomerDealingAndActiveInfo
                  customer={workOrderDetail?.customer}
                ></CustomerDealingAndActiveInfo>
              ) : (
                ""
              )
            }
          ></PropertyInfo>
        </Grid>
        <Grid item xs={6}>
          <PropertyInfo
            title="Ghi chú:"
            value={workOrderDetail?.note || ""}
          ></PropertyInfo>
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant="subtitle2"
            fontWeight={(theme) => theme.typography.fontWeightMedium}
          >
            Thông tin mặt hàng
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <PropertyInfo
            title="Mã hàng:"
            value={workOrderItem?.product?.code || ""}
          ></PropertyInfo>
        </Grid>
        <Grid item xs={6}>
          <PropertyInfo
            title="Tên  hàng:"
            value={
              workOrderItem?.product ? (
                <ProductNameAndActiveInfo
                  product={workOrderItem?.product}
                ></ProductNameAndActiveInfo>
              ) : (
                ""
              )
            }
          ></PropertyInfo>
        </Grid>
        <Grid item xs={6}>
          <PropertyInfo
            title="Mã vạch:"
            value={workOrderItem?.product?.barcode || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="ĐVT:"
            value={workOrderItem?.product?.unitOfCalculation || ""}
          ></PropertyInfo>
        </Grid>
        <Grid item xs={6}>
          <PropertyInfo
            title="Số lượng:"
            value={<NumberText value={workOrderItem?.amount}></NumberText>}
          ></PropertyInfo>
        </Grid>
        <Grid item xs={6}>
          <PropertyInfo
            title="Số lượng SX:"
            value={
              <NumberText value={workOrderItem?.productionAmount}></NumberText>
            }
          ></PropertyInfo>
        </Grid>
        <Grid item xs={6}>
          <PropertyInfo
            title="Số lượng thành phẩm:"
            value={
              <NumberText value={workOrderItem?.finishedAmount}></NumberText>
            }
          ></PropertyInfo>
        </Grid>
        <Grid item xs={6}>
          <PropertyInfo
            title="Số lượng hao hụt:"
            value={
              <NumberText value={workOrderItem?.wastageAmount}></NumberText>
            }
          ></PropertyInfo>
        </Grid>
        <Grid item xs={12}>
          <PropertyInfo
            title="Ghi chú:"
            value={workOrderItem?.note || ""}
          ></PropertyInfo>
        </Grid>
        <Grid item xs={12} container spacing={1}>
          <Grid item xs={4}>
            <DepartmentProcessItem
              woItemId={workOrderItem?.id || ""}
              type={DepartmentProcess.Print}
              title="Bộ phận in"
              amount={workOrderItem?.printAmount || undefined}
              date={workOrderItem?.printDate || ""}
            ></DepartmentProcessItem>
          </Grid>
          <Grid item xs={4}>
            <DepartmentProcessItem
              woItemId={workOrderItem?.id || ""}
              type={DepartmentProcess.Foil}
              title="Ép nhủ hiếm thị"
              amount={workOrderItem?.foilAmount || undefined}
              date={workOrderItem?.foilDate || ""}
            ></DepartmentProcessItem>
          </Grid>
          <Grid item xs={4}>
            <DepartmentProcessItem
              woItemId={workOrderItem?.id || ""}
              type={DepartmentProcess.OtherHandle}
              title="Xử lý khác"
              amount={workOrderItem?.otherHandleAmount || undefined}
              date={workOrderItem?.otherHandleDate || ""}
            ></DepartmentProcessItem>
          </Grid>
          <Grid item xs={4}>
            <DepartmentProcessItem
              woItemId={workOrderItem?.id || ""}
              type={DepartmentProcess.Shape}
              title="Bế định hình"
              amount={workOrderItem?.shapeAmount || undefined}
              date={workOrderItem?.shapeDate || ""}
            ></DepartmentProcessItem>
          </Grid>
          <Grid item xs={4}>
            <DepartmentProcessItem
              woItemId={workOrderItem?.id || ""}
              type={DepartmentProcess.Cut}
              title="Cắt thành phẩm"
              amount={workOrderItem?.cutAmount || undefined}
              date={workOrderItem?.cutDate || ""}
            ></DepartmentProcessItem>
          </Grid>
          <Grid item xs={4}>
            <DepartmentProcessItem
              woItemId={workOrderItem?.id || ""}
              type={DepartmentProcess.Paste}
              title="Dán thành phẩm"
              amount={workOrderItem?.pasteAmount || undefined}
              date={workOrderItem?.pasteDate || ""}
            ></DepartmentProcessItem>
          </Grid>
          <Grid item xs={4}>
            <DepartmentProcessItem
              woItemId={workOrderItem?.id || ""}
              type={DepartmentProcess.Package}
              title="Đóng gói"
              amount={workOrderItem?.packageAmount || undefined}
              date={workOrderItem?.packageDate || ""}
            ></DepartmentProcessItem>
          </Grid>
        </Grid>
      </Grid>
    </Stack>
  );
});
